import { createContext, useContext } from "react";

export interface WorkoutPermissionContextValue {
  dragAndDropEnabled: boolean;
  canEditItems: boolean;
  canEditSets: boolean;
  canLogSets: boolean;
  canEditWorkout: boolean;
  workoutItemSetShown: boolean;
  canAddComments: boolean;
  canAddRootItems: boolean;
  canImportFromLibrary: boolean;
  canEditAttributes: boolean;
}

export const workoutPermissionsContext =
  createContext<WorkoutPermissionContextValue>({
    dragAndDropEnabled: false,
    canEditItems: false,
    canEditSets: false,
    canLogSets: false,
    canEditWorkout: false,
    workoutItemSetShown: true,
    canAddComments: false,
    canAddRootItems: true,
    canImportFromLibrary: true,
    canEditAttributes: true,
  });

export function useWorkoutPermissions() {
  return useContext(workoutPermissionsContext);
}
